export default __webpack_public_path__ + "static/media/ratio-cholesterol.61e216c1.svg";